module.exports = __webpack_public_path__ + "static/media/back4.80b43d06.jpg";